/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Accountsync {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    //export interface IPostingAccount {
    //    id: number;
    //    name: string;
    //}

    enum AccountsyncTabsEnum {
        Main,
        Sync,
        Logs
    }

    interface IAccountsyncController {
        latestConnectionId: Guid;
        currentStep: AccountsyncTabsEnum;        
        connectionList: Array<IConnectionListItem>;  
        getConnections: () => void;
        openSyncTab: () => void;
    }

    export class AccountsyncController implements IAccountsyncController {

        public latestConnectionId: Guid;
        public currentStep = AccountsyncTabsEnum.Main;
        public connectionList: IConnectionListItem[]; 
        private qbAuthTab: any;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "$document",
            "$rootScope",
            "$scope",
            "$state",
            "$timeout"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $document: angular.IDocumentService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected $timeout: angular.ITimeoutService) {

            this.init();            
        }

        /**
         * Initialize QB integration Plugin
         * */
        init(): void {
            this.busyService.start();
            this.getConnections().then(() => {
                if (this.connectionList.length) this.currentStep = AccountsyncTabsEnum.Sync;
            }).finally(() => {
                this.busyService.stop();
            });

            this.$scope.$on('$destroy', this.resetQbAuthWindow.bind(this));
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        getConnections(): ng.IPromise<any> {
            return this.dataService.getListPaged('AccountSync', { criteria: { ObjectState: ObjectStateEnum.Active } }).then((data: Array<IConnectionListItem> | any) => {
                this.connectionList = data;
                return;
            });
        }

        resetQbAuthWindow(): void {
            // Close QB auth window if it present
            if (this.qbAuthTab) {
                this.qbAuthTab.close();                
            }
            this.qbAuthTab = null;
        }

        openSyncTab(): void {
            this.currentStep = 1;
        }

        setLatestConnectionId(connectionId: Guid) {
            this.latestConnectionId = connectionId;
        }

        stylizationTooltip(): void {
            this.$timeout(() => {
                // Getting menu content container by class names
                const container = this.$document[0].querySelector('.md-open-menu-container.md-active');
                const menuContentContainer = angular.element(container);
                // Adding custom class
                menuContentContainer.addClass('custom-tooltip');
            });
        }

        selectTab(): void {
            this.getConnections();

            if (this.currentStep === AccountsyncTabsEnum.Main) this.latestConnectionId = null;
            if (this.currentStep === AccountsyncTabsEnum.Sync) this.$scope.$broadcast('selectSyncTab', { latestConnectionId: this.latestConnectionId });
        }
    }

    angular.module('meevo.plugins.accountsync')
        .controller('meevo.plugins.accountsync.AccountsyncController', AccountsyncController);
}